import { RouteItem } from '@eastcoal/router/types/route'

import { TRADE_SESSION_PAGE_UUID } from './constants/uuid'

export const tradeSessionRoute: RouteItem = {
  title: '交易场次',
  uuid: TRADE_SESSION_PAGE_UUID,
  path: '/tradeSession',
  Component: () => import('./index')
}
